export default "__VITE_ASSET__$5L6fSDu__"